/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewAggregationFindings } from './CRSFSecReviewAggregationFindings';
import {
    CRSFSecReviewAggregationFindingsFromJSON,
    CRSFSecReviewAggregationFindingsFromJSONTyped,
    CRSFSecReviewAggregationFindingsToJSON,
} from './CRSFSecReviewAggregationFindings';

/**
 * 
 * @export
 * @interface CRSFSecReviewFindingsPagedResponseAgg
 */
export interface CRSFSecReviewFindingsPagedResponseAgg {
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingsPagedResponseAgg
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingsPagedResponseAgg
     */
    page_size?: number;
    /**
     * 
     * @type {Array<CRSFSecReviewAggregationFindings>}
     * @memberof CRSFSecReviewFindingsPagedResponseAgg
     */
    results?: Array<CRSFSecReviewAggregationFindings>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewFindingsPagedResponseAgg
     */
    total?: number;
}

/**
 * Check if a given object implements the CRSFSecReviewFindingsPagedResponseAgg interface.
 */
export function instanceOfCRSFSecReviewFindingsPagedResponseAgg(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CRSFSecReviewFindingsPagedResponseAggFromJSON(json: any): CRSFSecReviewFindingsPagedResponseAgg {
    return CRSFSecReviewFindingsPagedResponseAggFromJSONTyped(json, false);
}

export function CRSFSecReviewFindingsPagedResponseAggFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewFindingsPagedResponseAgg {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'page_size': !exists(json, 'page_size') ? undefined : json['page_size'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(CRSFSecReviewAggregationFindingsFromJSON)),
        'total': !exists(json, 'total') ? undefined : json['total'],
    };
}

export function CRSFSecReviewFindingsPagedResponseAggToJSON(value?: CRSFSecReviewFindingsPagedResponseAgg | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'page_size': value.page_size,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(CRSFSecReviewAggregationFindingsToJSON)),
        'total': value.total,
    };
}

